// extracted by mini-css-extract-plugin
export default {"container":"WidgetAddButton_container__OJn4y","card":"WidgetAddButton_card__s5Pyy","addButton":"WidgetAddButton_addButton__xVfgA"};